import clsx from 'clsx'

interface TagProps {
  label: string
  bgColor?: string
  textColor?: string
  width?: string | number
  className?: string
  tag?: 'p' | 'span'
}

export const Tag = ({ label, bgColor = '#e8e8e8', textColor = '#333333', width = 'auto', className }: TagProps) => {
  return (
    <div
      className={clsx(className)}
      style={{
        backgroundColor: bgColor,
        padding: '0 8px',
        borderRadius: '4px',
        display: 'inline-block',
        width: width,
        position: 'relative',
      }}
    >
      <div className="overlay absolute w-full h-full bg-[#d8dce5] opacity-20 left-0" />

      <span
        style={{
          color: textColor,
        }}
        className="text-[14px] font-semibold leading-[22px] relative"
      >
        {label}
      </span>
    </div>
  )
}
